import moment from "moment";
import api from "./Api";
import { handleApiError } from "../utils/apiUtils";

const DashBoard = process.env.REACT_APP_DASHBOARD_URL || "";
const DashboardAPI = api(DashBoard);

export interface ApiResponse<T> {
  result: T;
  isSuccess: boolean;
  message: string;
  statusCode: number;
}

export interface AppointmentSummary {
  caseAppointmentId: number;
  appointmentType: string;
  appointmentValues_Scheduled: number;
  appointmentValues_Completed: number;
  appointmentValues_Cancelled: number;
  appointmentValues_OnTime?: number;
}

export const getHistorianRecentActivity = async (limit: any): Promise<any> => {
  try {
    const response = await DashboardAPI.get<ApiResponse<any>>(
      `/api/historian/dashboard/recent-activity?limit=${limit}`,
    );

    return response.data?.result;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const getHistorianRushNotesSummary = async (
  limit: any,
): Promise<any> => {
  try {
    const response = await DashboardAPI.get<ApiResponse<any>>(
      `/api/historian/dashboard/latest-rush-notes?limit=${limit}`,
    );

    return response.data?.result;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const getHistorianCaseActionsSummary = async (
  interval: any,
): Promise<any[]> => {
  try {
    const response = await DashboardAPI.get(
      `/api/historian/dashboard/case-actions?interval=${interval}`,
    );
    return response.data?.result || [];
  } catch (error) {
    console.error("Error fetching case actions:", error);
    handleApiError(error);
    throw new Error("Unable to fetch case actions. Please try again later.");
  }
};

export const getHistorianWorkBreakDown = async (
  interval: any,
): Promise<any[]> => {
  try {
    const response = await DashboardAPI.get(
      `/api/historian/dashboard/workload-breakdown?interval=${interval}`,
    );
    return response.data?.result || [];
  } catch (error) {
    console.error("Error fetching case actions:", error);
    handleApiError(error);
    throw new Error("Unable to fetch case actions. Please try again later.");
  }
};

export const getHistoryReviewed = async (
  limit: any,
  interval: any,
): Promise<any[]> => {
  try {
    const response = await DashboardAPI.get(
      `/api/historian/dashboard/history-reviewed?topN=${limit}&interval=${interval}`,
    );
    return response.data?.result || [];
  } catch (error) {
    console.error("Error fetching case actions:", error);
    handleApiError(error);
    throw new Error("Unable to fetch case actions. Please try again later.");
  }
};

export const getAppointmentHistorianSummary = async (): Promise<
  AppointmentSummary[]
> => {
  try {
    const response = await DashboardAPI.get(
      "/api/historian/dashboard/appointments",
    );
    return response.data.result;
  } catch (error) {
    console.error("Error fetching appointment summary:", error);
    handleApiError(error);
    throw new Error(
      "Unable to fetch appointment summary. Please try again later.",
    );
  }
};

export const getHistorianAppointmentAnalyticsView = async (): Promise<any> => {
  try {
    const response = await DashboardAPI.get<ApiResponse<any>>(
      `/api/historian/dashboard/appointment-analytics`,
    );

    return response.data?.result;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const getHistorianInvoiceOverview = async (
  interval: any,
): Promise<any[]> => {
  try {
    const response = await DashboardAPI.get(
      `/api/historian/dashboard/invoice-overview?interval=${interval}`,
    );
    return response.data?.result || [];
  } catch (error) {
    console.error("Error fetching case actions:", error);
    handleApiError(error);
    throw new Error("Unable to fetch case actions. Please try again later.");
  }
};
